import axios from 'axios';
import React, { useState } from 'react'
import { AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';


interface Props {
  thing: Things,
  shop: Shops;


}
interface Shops {
  id: number,
  name: string,
  date: string,
  isDone: number,
}
interface Things {
  id: number,
  whatBuy: string,
  endDate: string,
  startDate: string,
  isDone: number,
  price: number,
}



const ThingsList: React.FC<Props> = ({ thing, shop }) => {
  const [edit, setEdit] = useState<boolean>(false);
  const [editThing, setEditThing] = useState<string>(thing.whatBuy);
  const [editCost, setEditCost] = useState<number>(thing.price);
  const [editStartDate, setEditStartDate] = useState<string>(thing.startDate);
  const [editEndDate, setEditEndDate] = useState<string>(thing.endDate);
  const [addOption, setAddOption] = useState<boolean>(false);
  const [done, setDone] = useState<boolean>(false);


  const deleteThing = (id: number) => {
    setAddOption(false)
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie usunięty",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteThing', {
          id: id,
        })
      }
    })

      .then((response) => {

      })

      .catch(function (error) {
        console.log("error!")

      })
  }



  const editThingToBuy = (e: React.FormEvent, id: number) => {
    setAddOption(false);
    e.preventDefault();

    axios.post(ipAddress + "/editThingToBuy", {
      whatBuy: editThing,
      price: editCost,
      startDate: editStartDate,
      endDate: editEndDate,
      id: id,
    })
      .then((response) => {

      })
      .catch(err => {
        console.log(err)

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditThing(thing.whatBuy);
    setEditCost(thing.price);
    setEditStartDate(thing.startDate);
    setEditEndDate(thing.endDate);
  }

  const handleChange = (id: number, isDone: number) => {
    if (isDone == 1) {
      isDone = 0
    } else {
      isDone = 1
    }
    axios.post(ipAddress + '/doneThingInShoppingList', {
      id: id,
      isDone: isDone,

    })


  };

  return (
    <div className='allThings'>
      {
        thing.isDone == 1 ?
          (
            <div>
              {
                thing.startDate.length > 0 ? (
                  <div className='thingsList'>

                    <input type="checkbox"
                    className='checkbox'
                      checked={true}
                      onChange={() => handleChange(thing.id, thing.isDone)}
                    ></input>
                     {
                    thing.price > 0 ? (
                      <s className='description'> {thing.whatBuy}  {thing.price} zł  </s>
                    ) :
                    (
                      <s className='description'> {thing.whatBuy}   </s>
                    )
                   }
                    <div>
                      <s>Promocja: {thing.startDate} - {thing.endDate}</s>
                    </div>

                    <span className='delete' onClick={() => deleteThing(thing.id)}><AiFillDelete /></span>


                  </div>
                ) : (
                  <div className='thingsList2'>
                    <input type="checkbox"
                    className='checkbox'
                      checked={true}
                      onChange={() => handleChange(thing.id, thing.isDone)}
                    ></input>
                     {
                    thing.price > 0 ? (
                      <s className='description'> {thing.whatBuy}  {thing.price} zł  </s>
                    ) :
                    (
                      <s className='description'> {thing.whatBuy}   </s>
                    )
                   }

                    <span className='delete' onClick={() => deleteThing(thing.id)}><AiFillDelete /></span>


                  </div>
                )
              }
            </div>
          ) :
          (
            <div>
              {
                thing.startDate.length > 0 ? (
                  <div className='thingsList'>

                    <input type="checkbox"
                      className='checkbox'
                      checked={false}
                      onChange={() => handleChange(thing.id, thing.isDone)}
                    ></input>
                 
                 {
                    thing.price > 0 ? (
                      <span className='description'> {thing.whatBuy}  {thing.price} zł  </span>
                    ) :
                    (
                      <span className='description'> {thing.whatBuy}   </span>
                    )
                   }
                    <div>
                      <span>Promocja: {thing.startDate} - {thing.endDate}</span>
                    </div>
                    <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
                    <span className='delete' onClick={() => deleteThing(thing.id)}><AiFillDelete /></span>


                  </div>
                ) : (
                  <div className='thingsList2'>
                    <input type="checkbox"
                      className='checkbox'
                      checked={false}
                      onChange={() => handleChange(thing.id, thing.isDone)}
                    ></input>
                    
                    {
                    thing.price > 0 ? (
                      <span className='description'> {thing.whatBuy}  {thing.price} zł  </span>
                    ) :
                    (
                      <span className='description'> {thing.whatBuy}   </span>
                    )
                   }

                    <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
                    <span className='delete' onClick={() => deleteThing(thing.id)}><AiFillDelete /></span>


                  </div>
                )
              }
            </div>
          )
      }




      {edit ? (
        <form className='thingEdit' onSubmit={(e) => { editThingToBuy(e, thing.id) }}>
          <button className='icon' id='close' onClick={() => close()} >X</button>
          <p id='shopName'>{shop.name}</p>
          <p>Edytuj koszt</p>
          <div className='thingToBuy'>
            <label htmlFor="thing">Co: </label>
            <input type="text"
              value={editThing}
              onChange={(e) => setEditThing(e.target.value)}
            ></input>
          </div>
          <div className='editPrice'>
            <label htmlFor="edit">Kwota: </label>
            <input type='number'
              value={editCost}
              onChange={(e) => setEditCost(e.target.valueAsNumber)}
            ></input>
            <span> zł</span>
          </div>
          <span id='promotion'>Promocja:</span>
          <div className='editStartDate'>
            <label htmlFor="edit">Od: </label>
            <input type='date'

              value={editStartDate}
              onChange={(e) => setEditStartDate(e.target.value)}
            ></input>

          </div>
          <div className='editEndDate'>
            <label htmlFor="edit">Do: </label>
            <input type='date'

              value={editEndDate}
              onChange={(e) => setEditEndDate(e.target.value)}
            ></input>

          </div>
          <button type='submit' id='submit'>OK</button>
        </form>
      ) : (
        <span></span>
      )
      }
    </div>
  )
}

export default ThingsList